import React from 'react'
import version from '../../config/version.json'
import './VersionView.scss'

export const VersionView = () => {
	return (
		<span id='version-view'>
			v{version.version} (api: {version.apiVersion})
		</span>
	)
}
